import { EMPTY_SYMBOL_24 } from "@sznds/icons";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { ADD_FIRM_LINK } from "~/report/const";
import Dialog from "~/ui/dialog";
import createSDSIcon from "~/ui/icon";
import { ICON_ADD_BUSINESS_24, ICON_ADD_PLACE_24, ICON_ARROW_DOWN_24, ICON_ARROW_RIGHT_24, ICON_EXCLAMATION_CIRCLE_24, ICON_FEEDBACK_24, ICON_MAP_EDIT_24 } from "~/ui/icons";
import { createReportHubButton } from "~/ui/reportHubButton";
import { createPremiumIcon, node, text } from "~/util/dom";
import { onAddBusiness, onAddPlace, onMapError, onMapNote, onPremium, onSomethingWrong } from "~/util/feedback";

export default class ReportHubDialog {
	#dialog: Dialog;

	constructor() {
		this.#dialog = new Dialog({
			className: "report-hub-dialog",
			title: _("report.hub.title"),
		});

		// text pod nadpisem
		this.#dialog.dom.content.append(node("p", { className: "report-hub-dialog__subtitle", innerHTML: _("report.hub.subtitle") }));

		// kontajner na tlacitka
		const buttons = node("div", { className: "report-hub-dialog__buttons" });

		this.#dialog.dom.content.append(buttons);

		// problemy s premiem
		const premiumReport = [];

		if (Mapy.CUS.user.premiumReport) {
			const premiumReportButton = createReportHubButton();

			premiumReportButton.append(createPremiumIcon(), node("span", { innerText: _("report.premiumMenuItem") }), createSDSIcon({ symbol: ICON_ARROW_RIGHT_24 }));
			premiumReportButton.addEventListener("click", () => {
				this.close();
				onPremium();
			}, false);
			premiumReport.push(premiumReportButton);
		}

		// chyba v mape
		const errorButton = createReportHubButton();

		errorButton.append(createSDSIcon({ symbol: ICON_MAP_EDIT_24 }), node("span", { innerText: _("report.mapError") }), createSDSIcon({ symbol: ICON_ARROW_RIGHT_24 }));
		errorButton.addEventListener("click", () => {
			this.close();
			if (!Mapy.Util.isSmallResolution()) {
				onMapError();
			}
		}, false);

		// neco nefunguje
		const wrongButton = createReportHubButton();

		wrongButton.append(createSDSIcon({ symbol: ICON_EXCLAMATION_CIRCLE_24 }), node("span", { innerText: _("report.somethingWentWrong") }), createSDSIcon({ symbol: ICON_ARROW_RIGHT_24 }));
		wrongButton.addEventListener("click", () => {
			this.close();
			onSomethingWrong();
		}, false);

		// pripominka k Mapy.cz
		const feedbackButton = createReportHubButton();

		feedbackButton.append(createSDSIcon({ symbol: ICON_FEEDBACK_24 }), node("span", { innerText: _("report.mapyczNote") }), createSDSIcon({ symbol: ICON_ARROW_RIGHT_24 }));
		feedbackButton.addEventListener("click", () => {
			this.close();
			onMapNote();
		}, false);

		// pridat misto
		const addPlaceButton = createReportHubButton();

		addPlaceButton.append(createSDSIcon({ symbol: ICON_ADD_PLACE_24 }), node("span", { innerText: _("report.addPlace2") }), createSDSIcon({ symbol: ICON_ARROW_RIGHT_24 }));
		addPlaceButton.addEventListener("click", () => {
			this.close();
			onAddPlace();
		}, false);

		let addBusinessItems: Array<HTMLElement> = [];
		const bussinessSubmenu = node("div", { className: "report-hub-dialog__submenu" });

		if (CONFIG.defaultLang === "cs") {
			// firma v Cesku
			const addBusinessCzechItem = node("a", { className: "ui-report-hub-button hidden", href: ADD_FIRM_LINK, target: "_blank", rel: "noopener", tabIndex: 0 });

			addBusinessCzechItem.append(createSDSIcon({ symbol: EMPTY_SYMBOL_24 }), text(_("report.inCzechia")));
			addBusinessCzechItem.addEventListener("click", () => {
				this.close();
				onAddBusiness(true);
			}, false);

			// firma v zahranici
			const addBusinessForeignItem = createReportHubButton({ className: "hidden" });

			addBusinessForeignItem.append(createSDSIcon({ symbol: EMPTY_SYMBOL_24 }), text(_("report.outsideCzechia")));
			addBusinessForeignItem.addEventListener("click", () => {
				this.close();
				onAddBusiness();
			}, false);

			// pridat firmu
			const addBusinessItem = node("div", { className: "ui-report-hub-button" });

			addBusinessItem.append(createSDSIcon({ symbol: ICON_ADD_BUSINESS_24 }), node("span", { innerText: _("report.addFirm") }), createSDSIcon({ symbol: ICON_ARROW_DOWN_24 }));
			addBusinessItem.addEventListener("click", () => {
				if (addBusinessCzechItem.classList.contains("hidden")) {
					addBusinessItem.classList.add("report-hub-dialog__submenu__visible");
					addBusinessCzechItem.classList.remove("hidden");
					addBusinessForeignItem.classList.remove("hidden");
				} else {
					addBusinessItem.classList.remove("report-hub-dialog__submenu__visible");
					addBusinessCzechItem.classList.add("hidden");
					addBusinessForeignItem.classList.add("hidden");
				}
			}, false);

			addBusinessItems = [
				addBusinessItem,
				addBusinessCzechItem,
				addBusinessForeignItem,
			];
		} else {
			// pridat firmu
			const addBusinessItem = createReportHubButton();

			addBusinessItem.append(createSDSIcon({ symbol: ICON_ADD_BUSINESS_24 }), text(_("report.addFirm")));
			addBusinessItem.addEventListener("click", () => {
				this.close();
				onAddBusiness();
			}, false);

			addBusinessItems = [
				addBusinessItem,
			];
		}

		// tlacitka
		bussinessSubmenu.append(...addBusinessItems);
		buttons.append(
			...premiumReport,
			...Mapy.Util.isSmallResolution() ? [] : [errorButton],
			wrongButton,
			feedbackButton,
			addPlaceButton,
			bussinessSubmenu,
		);
	}

	destroy() {
		this.#dialog.destroy();
	}

	open() {
		this.#dialog.open();
	}

	close() {
		this.#dialog.close();
	}
}
